// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-study-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.case-study-page main {
  flex: 1;
}

/* Flipbook Animation */
.case-study-page .flipbook-section {
  opacity: 0;
  transform: rotateY(-15deg) translateZ(-100px);
  transform-style: preserve-3d;
  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  perspective: 1000px;
}

.case-study-page .flipbook-section.flipbook-visible {
  opacity: 1;
  transform: rotateY(0deg) translateZ(0);
}

/* Hero Section */
.case-study-page .case-study-hero {
  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);
  color: white;
  padding: 6rem 0 4rem;
  position: relative;
  overflow: hidden;
}

.case-study-page .case-study-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  z-index: 1;
}

.case-study-page .case-study-hero .container {
  position: relative;
  z-index: 2;
}

.case-study-page .back-link {
  display: inline-flex;
  align-items: center;
  color: #ffbb00;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 2rem;
  transition: transform 0.3s ease, color 0.3s ease;
}

.case-study-page .back-link:hover {
  transform: translateX(-5px);
  color: #cc9900;
}

.case-study-page .hero-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: flex-start;
}

.case-study-page .hero-text {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.case-study-page .case-study-category {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 700;
  color: #ffbb00;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 0.5rem 1rem;
  background: rgba(255, 187, 0, 0.1);
  border-radius: 5px;
  width: fit-content;
}

.case-study-page .case-study-hero h1 {
  font-size: 3.5rem;
  font-weight: 900;
  line-height: 1.1;
  margin: 0;
  color: white;
}

.case-study-page .case-study-description {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #e0e0e0;
  margin: 0;
}

.case-study-page .case-study-meta {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}

.case-study-page .meta-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.case-study-page .meta-label {
  font-size: 0.85rem;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.case-study-page .meta-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffbb00;
}

.case-study-page .hero-actions {
  margin-top: 1rem;
}

.case-study-page .hero-image {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 187, 0, 0.9);
  background: white;
  padding: 10px;
}

.case-study-page .hero-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* Section Styles */
.case-study-page .case-study-section {
  padding: 5rem 0;
  background-color: #fff;
}

.case-study-page .case-study-section:nth-child(even) {
  background-color: #f8f8f8;
}

.case-study-page .case-study-section h2 {
  font-size: 2.5rem;
  font-weight: 900;
  color: #000;
  margin-bottom: 1.5rem;
  text-align: center;
}

.case-study-page .section-description {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #333;
  max-width: 900px;
  margin: 0 auto 2rem;
  text-align: center;
}

/* Challenge Section */
.case-study-page .challenge-points {
  list-style: none;
  padding: 0;
  max-width: 800px;
  margin: 0 auto;
}

.case-study-page .challenge-points li {
  padding: 1.25rem 1.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);
  border-left: 4px solid #ffbb00;
  border-radius: 8px;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.case-study-page .challenge-points li:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* Solution Section */
.case-study-page .solution-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-top: 3rem;
}

.case-study-page .technologies h3,
.case-study-page .features h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 1.5rem;
}

.case-study-page .tech-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.case-study-page .tech-tag {
  display: inline-block;
  padding: 0.75rem 1.25rem;
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  color: #000;
  font-weight: 700;
  border-radius: 25px;
  font-size: 0.9rem;
  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.case-study-page .tech-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.4);
}

.case-study-page .feature-list {
  list-style: none;
  padding: 0;
}

.case-study-page .feature-list li {
  padding: 1rem 0;
  padding-left: 2rem;
  position: relative;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;
  border-bottom: 1px solid #eee;
}

.case-study-page .feature-list li:last-child {
  border-bottom: none;
}

.case-study-page .feature-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #ffbb00;
  font-weight: 900;
  font-size: 1.2rem;
}

/* Results Section */
.case-study-page .results-section {
  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);
  color: white;
}

.case-study-page .results-section h2 {
  color: white;
}

.case-study-page .results-section .section-description {
  color: #e0e0e0;
}

.case-study-page .results-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
}

.case-study-page .metric-card {
  background: linear-gradient(135deg, rgba(255, 187, 0, 0.1) 0%, rgba(255, 187, 0, 0.05) 100%);
  border: 2px solid rgba(255, 187, 0, 0.3);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.case-study-page .metric-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(255, 187, 0, 0.2);
  border-color: #ffbb00;
}

.case-study-page .metric-value {
  font-size: 3rem;
  font-weight: 900;
  color: #ffbb00;
  line-height: 1;
  margin-bottom: 0.5rem;
  text-shadow: 0 0 20px rgba(255, 187, 0, 0.5);
}

.case-study-page .metric-label {
  font-size: 1rem;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;
}

.case-study-page .metric-description {
  font-size: 0.9rem;
  color: #ccc;
  line-height: 1.4;
}

.case-study-page .results-highlights {
  margin-top: 4rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.case-study-page .results-highlights h3 {
  font-size: 2rem;
  font-weight: 900;
  color: white;
  margin-bottom: 2rem;
  text-align: center;
}

.case-study-page .highlight-list {
  list-style: none;
  padding: 0;
}

.case-study-page .highlight-list li {
  padding: 1.5rem;
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-left: 4px solid #ffbb00;
  border-radius: 8px;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #e0e0e0;
  transition: transform 0.3s ease, background 0.3s ease;
}

.case-study-page .highlight-list li:hover {
  transform: translateX(5px);
  background: rgba(255, 255, 255, 0.1);
}

/* Security Section */
.case-study-page .security-section {
  background-color: #f8f8f8;
}

.case-study-page .security-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
}

.case-study-page .security-metric {
  background: #000;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 187, 0, 0.3);
}

.case-study-page .security-metric-value {
  font-size: 2.75rem;
  font-weight: 900;
  color: #ffbb00;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.case-study-page .security-metric-label {
  font-size: 1rem;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;
}

.case-study-page .security-metric-description {
  font-size: 0.9rem;
  color: #ccc;
  line-height: 1.4;
}

.case-study-page .security-pillars {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.case-study-page .security-pillar {
  background: white;
  border-radius: 12px;
  border-top: 4px solid #ffbb00;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.case-study-page .security-pillar h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #000;
  margin: 0 0 0.75rem;
}

.case-study-page .security-pillar p {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #555;
  margin: 0 0 1rem;
}

.case-study-page .security-pillar .feature-list li {
  font-size: 1rem;
  padding: 0.6rem 0 0.6rem 2rem;
}

/* Testimonial Section */
.case-study-page .testimonial-section {
  background: linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%);
}

.case-study-page .testimonial {
  max-width: 900px;
  margin: 0 auto;
  padding: 3rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border-left: 5px solid #ffbb00;
}

.case-study-page .testimonial-quote {
  font-size: 1.5rem;
  line-height: 1.8;
  color: #333;
  font-style: italic;
  margin: 0 0 2rem 0;
  position: relative;
  padding-left: 2rem;
}

.case-study-page .testimonial-quote::before {
  content: '"';
  position: absolute;
  left: 0;
  top: -10px;
  font-size: 4rem;
  color: #ffbb00;
  opacity: 0.3;
  font-family: Georgia, serif;
}

.case-study-page .testimonial-author {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 2px solid #eee;
}

.case-study-page .testimonial-author cite {
  font-style: normal;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.case-study-page .testimonial-author strong {
  font-size: 1.2rem;
  color: #000;
  font-weight: 700;
}

.case-study-page .testimonial-role {
  font-size: 1rem;
  color: #666;
}

/* CTA Section */
.case-study-page .case-study-cta {
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  color: #000;
  padding: 5rem 0;
  text-align: center;
}

.case-study-page .case-study-cta h2 {
  font-size: 2.5rem;
  font-weight: 900;
  margin-bottom: 1rem;
  color: #000;
}

.case-study-page .case-study-cta p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #333;
}

.case-study-page .cta-actions {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Not Found */
.case-study-not-found {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.case-study-not-found .not-found-content {
  text-align: center;
  padding: 5rem 2rem;
  max-width: 600px;
  margin: 0 auto;
}

.case-study-not-found .not-found-content h1 {
  font-size: 3rem;
  font-weight: 900;
  color: #000;
  margin-bottom: 1rem;
}

.case-study-not-found .not-found-content p {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
}

/* Responsive Design */
@media (max-width: 992px) {
  .case-study-page .hero-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .case-study-page .case-study-hero h1 {
    font-size: 2.5rem;
  }

  .case-study-page .solution-details,
  .case-study-page .security-pillars {
    grid-template-columns: 1fr;
  }

  .case-study-page .results-metrics {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

@media (max-width: 768px) {
  .case-study-page .case-study-hero {
    padding: 4rem 0 3rem;
  }

  .case-study-page .case-study-hero h1 {
    font-size: 2rem;
  }

  .case-study-page .case-study-description {
    font-size: 1rem;
  }

  .case-study-page .case-study-section {
    padding: 3rem 0;
  }

  .case-study-page .case-study-section h2 {
    font-size: 2rem;
  }

  .case-study-page .metric-value {
    font-size: 2.5rem;
  }

  .case-study-page .testimonial-quote {
    font-size: 1.2rem;
    padding-left: 1.5rem;
  }

  .case-study-page .case-study-cta h2 {
    font-size: 2rem;
  }

  .case-study-page .cta-actions {
    flex-direction: column;
    align-items: stretch;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/case-studies/CaseStudyPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,6CAA6C;EAC7C,4BAA4B;EAC5B,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,0DAA0D;EAC1D,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;GAIC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,wCAAwC;EACxC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0DAA0D;EAC1D,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,4FAA4F;EAC5F,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".case-study-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.case-study-page main {\n  flex: 1;\n}\n\n/* Flipbook Animation */\n.case-study-page .flipbook-section {\n  opacity: 0;\n  transform: rotateY(-15deg) translateZ(-100px);\n  transform-style: preserve-3d;\n  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  perspective: 1000px;\n}\n\n.case-study-page .flipbook-section.flipbook-visible {\n  opacity: 1;\n  transform: rotateY(0deg) translateZ(0);\n}\n\n/* Hero Section */\n.case-study-page .case-study-hero {\n  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);\n  color: white;\n  padding: 6rem 0 4rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.case-study-page .case-study-hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.7) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  z-index: 1;\n}\n\n.case-study-page .case-study-hero .container {\n  position: relative;\n  z-index: 2;\n}\n\n.case-study-page .back-link {\n  display: inline-flex;\n  align-items: center;\n  color: #ffbb00;\n  text-decoration: none;\n  font-weight: 600;\n  margin-bottom: 2rem;\n  transition: transform 0.3s ease, color 0.3s ease;\n}\n\n.case-study-page .back-link:hover {\n  transform: translateX(-5px);\n  color: #cc9900;\n}\n\n.case-study-page .hero-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  align-items: flex-start;\n}\n\n.case-study-page .hero-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.case-study-page .case-study-category {\n  display: inline-block;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #ffbb00;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 187, 0, 0.1);\n  border-radius: 5px;\n  width: fit-content;\n}\n\n.case-study-page .case-study-hero h1 {\n  font-size: 3.5rem;\n  font-weight: 900;\n  line-height: 1.1;\n  margin: 0;\n  color: white;\n}\n\n.case-study-page .case-study-description {\n  font-size: 1.2rem;\n  line-height: 1.8;\n  color: #e0e0e0;\n  margin: 0;\n}\n\n.case-study-page .case-study-meta {\n  display: flex;\n  gap: 2rem;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n}\n\n.case-study-page .meta-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.case-study-page .meta-label {\n  font-size: 0.85rem;\n  color: #999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.case-study-page .meta-value {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #ffbb00;\n}\n\n.case-study-page .hero-actions {\n  margin-top: 1rem;\n}\n\n.case-study-page .hero-image {\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  border: 2px solid rgba(255, 187, 0, 0.9);\n  background: white;\n  padding: 10px;\n}\n\n.case-study-page .hero-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n}\n\n/* Section Styles */\n.case-study-page .case-study-section {\n  padding: 5rem 0;\n  background-color: #fff;\n}\n\n.case-study-page .case-study-section:nth-child(even) {\n  background-color: #f8f8f8;\n}\n\n.case-study-page .case-study-section h2 {\n  font-size: 2.5rem;\n  font-weight: 900;\n  color: #000;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.case-study-page .section-description {\n  font-size: 1.2rem;\n  line-height: 1.8;\n  color: #333;\n  max-width: 900px;\n  margin: 0 auto 2rem;\n  text-align: center;\n}\n\n/* Challenge Section */\n.case-study-page .challenge-points {\n  list-style: none;\n  padding: 0;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.case-study-page .challenge-points li {\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);\n  border-left: 4px solid #ffbb00;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  line-height: 1.6;\n  color: #333;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.case-study-page .challenge-points li:hover {\n  transform: translateX(5px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n/* Solution Section */\n.case-study-page .solution-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  margin-top: 3rem;\n}\n\n.case-study-page .technologies h3,\n.case-study-page .features h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 1.5rem;\n}\n\n.case-study-page .tech-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.case-study-page .tech-tag {\n  display: inline-block;\n  padding: 0.75rem 1.25rem;\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  color: #000;\n  font-weight: 700;\n  border-radius: 25px;\n  font-size: 0.9rem;\n  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.case-study-page .tech-tag:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.4);\n}\n\n.case-study-page .feature-list {\n  list-style: none;\n  padding: 0;\n}\n\n.case-study-page .feature-list li {\n  padding: 1rem 0;\n  padding-left: 2rem;\n  position: relative;\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #333;\n  border-bottom: 1px solid #eee;\n}\n\n.case-study-page .feature-list li:last-child {\n  border-bottom: none;\n}\n\n.case-study-page .feature-list li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: #ffbb00;\n  font-weight: 900;\n  font-size: 1.2rem;\n}\n\n/* Results Section */\n.case-study-page .results-section {\n  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);\n  color: white;\n}\n\n.case-study-page .results-section h2 {\n  color: white;\n}\n\n.case-study-page .results-section .section-description {\n  color: #e0e0e0;\n}\n\n.case-study-page .results-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 2rem;\n  margin: 3rem 0;\n}\n\n.case-study-page .metric-card {\n  background: linear-gradient(135deg, rgba(255, 187, 0, 0.1) 0%, rgba(255, 187, 0, 0.05) 100%);\n  border: 2px solid rgba(255, 187, 0, 0.3);\n  border-radius: 12px;\n  padding: 2rem;\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.case-study-page .metric-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(255, 187, 0, 0.2);\n  border-color: #ffbb00;\n}\n\n.case-study-page .metric-value {\n  font-size: 3rem;\n  font-weight: 900;\n  color: #ffbb00;\n  line-height: 1;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 0 20px rgba(255, 187, 0, 0.5);\n}\n\n.case-study-page .metric-label {\n  font-size: 1rem;\n  font-weight: 700;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 0.5rem;\n}\n\n.case-study-page .metric-description {\n  font-size: 0.9rem;\n  color: #ccc;\n  line-height: 1.4;\n}\n\n.case-study-page .results-highlights {\n  margin-top: 4rem;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.case-study-page .results-highlights h3 {\n  font-size: 2rem;\n  font-weight: 900;\n  color: white;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.case-study-page .highlight-list {\n  list-style: none;\n  padding: 0;\n}\n\n.case-study-page .highlight-list li {\n  padding: 1.5rem;\n  margin-bottom: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-left: 4px solid #ffbb00;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #e0e0e0;\n  transition: transform 0.3s ease, background 0.3s ease;\n}\n\n.case-study-page .highlight-list li:hover {\n  transform: translateX(5px);\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Security Section */\n.case-study-page .security-section {\n  background-color: #f8f8f8;\n}\n\n.case-study-page .security-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 2rem;\n  margin: 3rem 0;\n}\n\n.case-study-page .security-metric {\n  background: #000;\n  border-radius: 12px;\n  padding: 2rem;\n  text-align: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  border: 2px solid rgba(255, 187, 0, 0.3);\n}\n\n.case-study-page .security-metric-value {\n  font-size: 2.75rem;\n  font-weight: 900;\n  color: #ffbb00;\n  line-height: 1;\n  margin-bottom: 0.5rem;\n}\n\n.case-study-page .security-metric-label {\n  font-size: 1rem;\n  font-weight: 700;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 0.5rem;\n}\n\n.case-study-page .security-metric-description {\n  font-size: 0.9rem;\n  color: #ccc;\n  line-height: 1.4;\n}\n\n.case-study-page .security-pillars {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n}\n\n.case-study-page .security-pillar {\n  background: white;\n  border-radius: 12px;\n  border-top: 4px solid #ffbb00;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n}\n\n.case-study-page .security-pillar h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #000;\n  margin: 0 0 0.75rem;\n}\n\n.case-study-page .security-pillar p {\n  font-size: 1.05rem;\n  line-height: 1.7;\n  color: #555;\n  margin: 0 0 1rem;\n}\n\n.case-study-page .security-pillar .feature-list li {\n  font-size: 1rem;\n  padding: 0.6rem 0 0.6rem 2rem;\n}\n\n/* Testimonial Section */\n.case-study-page .testimonial-section {\n  background: linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%);\n}\n\n.case-study-page .testimonial {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 3rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  border-left: 5px solid #ffbb00;\n}\n\n.case-study-page .testimonial-quote {\n  font-size: 1.5rem;\n  line-height: 1.8;\n  color: #333;\n  font-style: italic;\n  margin: 0 0 2rem 0;\n  position: relative;\n  padding-left: 2rem;\n}\n\n.case-study-page .testimonial-quote::before {\n  content: '\"';\n  position: absolute;\n  left: 0;\n  top: -10px;\n  font-size: 4rem;\n  color: #ffbb00;\n  opacity: 0.3;\n  font-family: Georgia, serif;\n}\n\n.case-study-page .testimonial-author {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 2px solid #eee;\n}\n\n.case-study-page .testimonial-author cite {\n  font-style: normal;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.case-study-page .testimonial-author strong {\n  font-size: 1.2rem;\n  color: #000;\n  font-weight: 700;\n}\n\n.case-study-page .testimonial-role {\n  font-size: 1rem;\n  color: #666;\n}\n\n/* CTA Section */\n.case-study-page .case-study-cta {\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  color: #000;\n  padding: 5rem 0;\n  text-align: center;\n}\n\n.case-study-page .case-study-cta h2 {\n  font-size: 2.5rem;\n  font-weight: 900;\n  margin-bottom: 1rem;\n  color: #000;\n}\n\n.case-study-page .case-study-cta p {\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n  color: #333;\n}\n\n.case-study-page .cta-actions {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Not Found */\n.case-study-not-found {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.case-study-not-found .not-found-content {\n  text-align: center;\n  padding: 5rem 2rem;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.case-study-not-found .not-found-content h1 {\n  font-size: 3rem;\n  font-weight: 900;\n  color: #000;\n  margin-bottom: 1rem;\n}\n\n.case-study-not-found .not-found-content p {\n  font-size: 1.2rem;\n  color: #666;\n  margin-bottom: 2rem;\n}\n\n/* Responsive Design */\n@media (max-width: 992px) {\n  .case-study-page .hero-content {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n\n  .case-study-page .case-study-hero h1 {\n    font-size: 2.5rem;\n  }\n\n  .case-study-page .solution-details,\n  .case-study-page .security-pillars {\n    grid-template-columns: 1fr;\n  }\n\n  .case-study-page .results-metrics {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .case-study-page .case-study-hero {\n    padding: 4rem 0 3rem;\n  }\n\n  .case-study-page .case-study-hero h1 {\n    font-size: 2rem;\n  }\n\n  .case-study-page .case-study-description {\n    font-size: 1rem;\n  }\n\n  .case-study-page .case-study-section {\n    padding: 3rem 0;\n  }\n\n  .case-study-page .case-study-section h2 {\n    font-size: 2rem;\n  }\n\n  .case-study-page .metric-value {\n    font-size: 2.5rem;\n  }\n\n  .case-study-page .testimonial-quote {\n    font-size: 1.2rem;\n    padding-left: 1.5rem;\n  }\n\n  .case-study-page .case-study-cta h2 {\n    font-size: 2rem;\n  }\n\n  .case-study-page .cta-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
